import { useState } from "react";

export const SCREEN_PERIOD_DEFAULTS = Object.freeze({
  atendimento: "tudo",
  prospeccao: "tudo",
  centralConversas: "tudo",
  dashboard: "este_mes",
  historico: "este_mes",
  leadsKanban: "este_mes",
  leadsDashboard: "este_mes",
  leadsConsultores: "este_mes",
  admin: "este_mes",
  recebimentos: "este_mes",
});

export function createScreenPeriodFilters(screen, base = {}) {
  const period = SCREEN_PERIOD_DEFAULTS[screen];
  if (!period) throw new Error(`Tela sem padrão de período: ${screen}`);
  return { ...base, period, customFrom:"", customTo:"" };
}

export function useScreenPeriodFilters(screen, base = {}) {
  return useState(() => createScreenPeriodFilters(screen, base));
}